var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.close),expression:"close"}],staticClass:"dropdown relative"},[_vm._t("default",null,{"toggle":_vm.toggle}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_vm._t("menu",null,{"toggle":_vm.toggle}):_vm._e()],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee3dae6e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dropdown.vue
// module id = null
// module chunks = 